import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Link from "@mui/material/Link"
import Stack from "@mui/material/Stack"
import { usePathname } from "next/navigation"
import { FC } from "react"

import { Button } from "src/components/common/button"
import { create } from "src/helpers/bem"
import { getPath } from "src/helpers/paths"
import { useTranslation } from "src/hooks/translation"
import { useLocale } from "src/states/locale"

import styles from "./SubHeader.module.scss"
const bem = create(styles, "SubHeader")

interface BreadcrumbProps {
  homeButton?: boolean
  accountArea?: boolean
  shopArea?: boolean
  additionals?: JSX.Element
  lastBreadcrumbTitle?: string
}

export const SubHeader: FC<BreadcrumbProps> = ({
  homeButton = false,
  accountArea = false,
  shopArea = false,
  additionals,
  lastBreadcrumbTitle,
}) => {
  const locale = useLocale()
  const { messages: translations } = useTranslation()
  const accountBreadcrubsTranslations =
    translations.pages.account.overview.breadcrumbs

  const pathname = usePathname()

  const renderLastBreadcrumb = () => {
    let title = lastBreadcrumbTitle
    if (pathname === getPath(locale, "home")) {
      return null
    }
    if (pathname === getPath(locale, "account")) {
      title = accountBreadcrubsTranslations.profile
    }
    if (pathname === getPath(locale, "bookings")) {
      title = accountBreadcrubsTranslations.bookings
    }
    if (pathname === getPath(locale, "orders")) {
      title = accountBreadcrubsTranslations.service
    }
    if (pathname === getPath(locale, "service")) {
      title = accountBreadcrubsTranslations.support
    }
    if (pathname === getPath(locale, "shop")) {
      title = accountBreadcrubsTranslations.shop
    }
    return <Link href="">{title}</Link>
  }

  return (
    <div className={bem("Header")}>
      <div className={bem("Header__Breadcrumb")}>
        <Stack
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            className={bem("breadcrumbs")}
            separator="»"
          >
            {homeButton && (
              <Link href={getPath(locale, "home")}>
                {accountBreadcrubsTranslations.home}
              </Link>
            )}
            {accountArea && (
              <Link href={getPath(locale, "account")}>
                {accountBreadcrubsTranslations.account}
              </Link>
            )}
            {renderLastBreadcrumb()}
          </Breadcrumbs>
          <Stack alignItems={"center"} direction={"row"}>
            {homeButton && (
              <Button
                buttonType="secondary"
                className={bem("back__button")}
                startIcon={<KeyboardBackspaceIcon />}
                title={accountBreadcrubsTranslations.button}
                onClick={() => {
                  window.location.href = getPath(locale, "home")
                }}
              />
            )}
            {additionals}
          </Stack>
        </Stack>
      </div>
    </div>
  )
}
